module.exports = __webpack_public_path__ + "img/yabukita-h.d4d064ff.jpg";